"use strict";

import initModulesInScope from "@elements/init-modules-in-scope";
import {scrollTo} from "./scrollTo";

export function initInScope($scope) {
    let $forms = $scope.find('.js-application-form');

    $forms.each(function () {
        let $form = $(this);
        let $steps = $form.find('.js-application-form__step');
        let $progressSteps = $form.find('.js-application-steps__item');
        let $addFieldWrapper = $form.find('.js-add-field__wrapper');
        let addId = 0;

        $addFieldWrapper.each(function(){
            let $fieldWrapper = $(this);
            let $addButton = $fieldWrapper.find('.js-add-field--add');

            $addButton.on('click', function(evt) {
                evt.preventDefault();
                let $template = $($fieldWrapper.find('.js-add-field__template').html());
                let $templateNew = $template.clone();
                $templateNew.find('.js-add-field--delete').on('click', function (evt) {
                    $(this).closest('.js-add-field__field').remove();
                });

                $templateNew.find('.js-add-field__form-item').each(function(index){
                    let $itemInput = $(this).find('.js-add-field__input');
                    let $itemLabel = $(this).find('.js-add-field__label');
                    let $hiddenInput = $(this).find('.js-add-field__input-hidden');
                    let itemName = $itemInput.attr('id');
                    let hiddenItemName = $hiddenInput.attr('name');

                    $itemLabel.attr('for', itemName+'-'+addId+'[]');
                    $itemInput.attr('id', itemName+'-'+addId+'[]');
                    $itemInput.attr('name', itemName+'-'+addId+'[]');
                    $hiddenInput.attr('name', hiddenItemName+'-'+addId+'[]');
                });

                $templateNew.insertBefore($addButton);
                initModulesInScope($fieldWrapper);
                addId++;
            })
        });

        $steps.each(function (index) {
            $(this).find(':input').attr('data-parsley-group', 'block-' + index);
        });
       
        navigateTo(0); // Start at the beginning

        $form.find('.js-application-form__next').on('click', function (evt) {
            evt.preventDefault();

            $form.parsley().whenValidate({
                group: 'block-' + curIndex()
            }).done(function () {
                navigateTo(curIndex() + 1);
                scrollTo($form, 300);
            });
        });

        $form.find('.js-application-form__prev').click(function (evt) {
            evt.preventDefault();
            navigateTo(curIndex() - 1);
            scrollTo($form, 300);
        });

        function curIndex() {
            return $steps.index($steps.filter('.is-current'));
        }

        function navigateTo(index) {
            $steps.removeClass('is-current').eq(index).addClass('is-current');
            $progressSteps.removeClass('is-complete');
            $progressSteps.removeClass('is-active').eq(index).addClass('is-active');
            let $prevBtn = $form.find('.js-application-form__prev');
            let $nextBtn = $form.find('.js-application-form__next');
            let $submitBtn = $form.find('.js-application-form__submit');

            if (index !== 0) {
                $prevBtn.attr('hidden', false);
                $progressSteps.slice(0, index).addClass('is-complete');
            } else {
                $prevBtn.attr('hidden', true)
            }

            if (index >= $steps.length - 1) {
                $nextBtn.attr('hidden', true);
                $submitBtn.attr('hidden', false);
            } else {
                $nextBtn.attr('hidden', false);
                $submitBtn.attr('hidden', true);
            }
        }

    });
}
